<div class="modal-header">
  <mat-icon class="clickable text-transparent">&nbsp;&nbsp;&nbsp;&nbsp;</mat-icon>
  <h4 class="modal-title">Import {{ entity }}</h4>
  <mat-icon class="close clickable me-4" (click)="onClose()">close</mat-icon>
</div>

<div class="modal-body">
  <input type="file" (change)="onFileChange($event)" class="mb-4" />

  <div class="loader" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  <form *ngIf="headers.length" (ngSubmit)="startImport()">
    <h5 class="mb-2">Preview & Map Columns</h5>
    <div class="table-responsive">
      <table class="table table-sm table-bordered w-100 mb-4">
        <thead>
          <tr>
            <td *ngFor="let header of headers; let colIndex = index">
              <select [(ngModel)]="columnMapping[headerLabels[colIndex]]" name="map_{{ colIndex }}" class="form-select">
                <option [ngValue]="null">-- Map To --</option>
                <option *ngFor="let field of systemFields" [value]="field.key">
                  {{ field.label }}
                </option>
              </select>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of previewRows">
            <td *ngFor="let header of headers"><b>{{ row[header] }}</b></td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="d-flex gap-2 justify-content-end" *ngIf="headers.length">
    <button type="submit" class="btn btn-primary" (click)="startImport()">Start Import</button>
    <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
  </div>
</div>